import freeEmailDomains from "free-email-domains";

const domainSet = new Set<string>(freeEmailDomains);

export function isPersonalDomain(domain: string): boolean {
  return domainSet.has(domain.toLowerCase());
}

export function isPersonalEmail(email: string): boolean {
  const domain = email.split("@")[1]?.toLowerCase();
  return domain ? isPersonalDomain(domain) : false;
}
